import { z } from 'zod';

const nullishStringSchema = z.string().nullish();

export const accreditationStageSchema = z.enum([
  'pending_review',
  'data_rejected',
  'pending_data',
  'pending_data_review',
  'data_extra_rejected',
  'pending_contract_sign',
  'pending_contract_review',
  'contract_rejected',
  'approved',
  'okved_failed',
  'pending_edo_sign',
]);

export type AccreditationStage = z.output<typeof accreditationStageSchema>;

export const companyTypeSchema = z.enum(['ip', 'ul']);

export type CompanyType = z.infer<typeof companyTypeSchema>;

export const companySchema = z
  .object({
    id: z.number().optional(),
    legal_name: nullishStringSchema,
    marketing_name: nullishStringSchema,
    inn: nullishStringSchema,
    kpp: nullishStringSchema,
    ogrn: nullishStringSchema,
    ogrnip: nullishStringSchema,
    legal_address: nullishStringSchema,
    actual_address: nullishStringSchema,
    accreditation_stage: accreditationStageSchema.nullish(),
    is_blocked: z.boolean().optional(),
    type: companyTypeSchema.nullish(),
  })
  .transform((raw) => ({
    id: raw.id,
    legalName: raw.legal_name ?? null,
    marketingName: raw.marketing_name ?? null,
    inn: raw.inn ?? null,
    kpp: raw.kpp ?? null,
    ogrn: raw.ogrn ?? null,
    ogrnip: raw.ogrnip ?? null,
    legalAddress: raw.legal_address ?? null,
    actualAddress: raw.actual_address ?? null,
    accreditationStage: raw.accreditation_stage ?? null,
    isBlocked: raw.is_blocked ?? false,
    type: raw.type ?? null,
  }));

export type Company = z.infer<typeof companySchema>;
